import { AllowAccountRes } from '../../api/orderManage'
import { FinanicialInvoiceType } from './components/InvoiceEntryBatchModal'
import { ActionType, CustomAction } from '../../global'
import { orderTypeData } from '../../tools/util'

// 暂存/提交按钮类型
export type BtnType = 'temporaryStorage' | 'submit'
export const FINANCIAL_INVOICE_FILE_TYPE = '.pdf,.jpg,.png,.jpeg'
export type OrderType = (typeof orderTypeData)[number]['des']

export type SendTicketAddressType = '万聚' | '总部'
export type AddressInfo = {
  name: string
  phone: string
  address: string
  desp?: string
}
export const sendTicketAddressDict: Record<SendTicketAddressType, AddressInfo> =
  {
    总部: {
      name: '王婷燕',
      phone: '18814835585',
      address:
        '浙江省杭州市拱墅区永福桥路与新天地街交叉口南180米咸亨科技大厦8楼',
    },
    万聚: {
      name: '王亚',
      phone: '17855973107',
      address: '浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室',
    },
  }

export function joinAddressInfo(addressInfo: AddressInfo | null) {
  if (!addressInfo) {
    return ''
  }
  return `${addressInfo.name}，${addressInfo.phone}，${addressInfo.address}`
}
export interface RouteParams {
  data?: AllowAccountRes[]
  id?: string // 存在时为暂存、驳回状态 可以修改页面数据
  invoiceState?: string // 发票状态
  rejectReason?: string // 驳回原因
  invoiceData?: any[] // 发票列表
  type?: OrderType // 发票单类型
  orderType?: string
  titleOfTheContract?: string
  sendTicketAddressType?: SendTicketAddressType
}

interface State {
  dataSource: AllowAccountRes[]
  isAddModalVisivle: boolean
  selectedRowKeys: string[]
  selectedRows: AllowAccountRes[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  routeParams: RouteParams
  originRemovedList: AllowAccountRes[]
  invoiceBatchModalVisible: boolean
  batchUploadLoading: boolean
  invoiceEntryType: FinanicialInvoiceType
  invoiceListData: any[]
  previewFileUrl: string
  isPreviewModalVisible: boolean
  allInvoicePrice: number
  allOrderPrice: number
  addInvoiceEntrySubmit: boolean
  isModalOpen: boolean
  invoiceDetailData: any[]
  currentInvoice: any
  invoiceDetailChangeFlag: boolean
  checkingResult: any
  exrpotInvoiceTip: boolean
  delInvoiceIdList: string[]
  delOrderIdList: string[]
  isTemporaryStorageLoading: boolean
  addInvoiceEntryId: string
  invoiceDetail: any
  okBtnLoading: boolean
  temporaryStorageDisabled: boolean
  pageLoading: boolean
  logisticsCompanyList: any
  fileRequire: boolean
  logisticsInfo: {
    logisticsCompany: string
    logisticsNum: string
  }
  deleteFileIds: string[]
  sendTicketAddressType: undefined
}

type Action = ActionType<State>

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  selectedRows: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  routeParams: {
    data: [],
    id: '',
  },
  originRemovedList: [],
  invoiceBatchModalVisible: false,
  batchUploadLoading: false,
  invoiceEntryType: 'batchUpload',
  invoiceListData: [],
  previewFileUrl: '',
  isPreviewModalVisible: false,
  allInvoicePrice: 0,
  allOrderPrice: 0,
  addInvoiceEntrySubmit: false,
  isModalOpen: false,
  invoiceDetailData: [],
  currentInvoice: {},
  invoiceDetailChangeFlag: false,
  checkingResult: {},
  exrpotInvoiceTip: false,
  delInvoiceIdList: [],
  delOrderIdList: [],
  isTemporaryStorageLoading: false,
  addInvoiceEntryId: '',
  invoiceDetail: {},
  okBtnLoading: false,
  temporaryStorageDisabled: false,
  pageLoading: false,
  logisticsCompanyList: [],
  fileRequire: false,
  logisticsInfo: {
    logisticsCompany: '',
    logisticsNum: '',
  },
  deleteFileIds: [],
  sendTicketAddressType: undefined,
}

export default function reducer(
  state: State = initialState,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setIsAddModalVisivleAction':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceDataAction':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setOriginRemovedListAction':
      newstate.originRemovedList = action.payload
      return newstate
    case 'setInvoiceBatchModalVisibleAction':
      newstate.invoiceBatchModalVisible = action.payload
      return newstate
    case 'setBatchUploadLoadingAction':
      newstate.batchUploadLoading = action.payload
      return newstate
    case 'setInvoiceEntryTypeAction':
      newstate.invoiceEntryType = action.payload
      return newstate
    case 'setInvoiceListDataAction':
      newstate.invoiceListData = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setAllInvoicePriceAction':
      newstate.allInvoicePrice = action.payload
      return newstate
    case 'setAllOrderPriceAction':
      newstate.allOrderPrice = action.payload
      return newstate
    case 'setAddInvoiceEntrySubmitAction':
      newstate.addInvoiceEntrySubmit = action.payload
      return newstate
    case 'setIsModalOpenAction':
      newstate.isModalOpen = action.payload
      return newstate
    case 'setInvoiceDetailDataAction':
      newstate.invoiceDetailData = action.payload
      return newstate
    case 'setCurrentInvoiceAction':
      newstate.currentInvoice = action.payload
      return newstate
    case 'setInvoiceDetailChangeFlagAction':
      newstate.invoiceDetailChangeFlag = action.payload
      return newstate
    case 'setCheckingResultAction':
      newstate.checkingResult = action.payload
      return newstate
    case 'setExrpotInvoiceTipAction':
      newstate.exrpotInvoiceTip = action.payload
      return newstate
    case 'setDelInvoiceIdListAction':
      newstate.delInvoiceIdList = action.payload
      return newstate
    case 'setDelOrderIdListAction':
      newstate.delOrderIdList = action.payload
      return newstate
    case 'setIsTemporaryStorageLoadingAction':
      newstate.isTemporaryStorageLoading = action.payload
      return newstate
    case 'setAddInvoiceEntryIdAction':
      newstate.addInvoiceEntryId = action.payload
      return newstate
    case 'setInvoiceDetailAction':
      newstate.invoiceDetail = action.payload
      return newstate
    case 'setOkBtnLoadingAction':
      newstate.okBtnLoading = action.payload
      return newstate
    case 'setTemporaryStorageDisabledAction':
      newstate.temporaryStorageDisabled = action.payload
      return newstate
    case 'setPageLoadingAction':
      newstate.pageLoading = action.payload
      return newstate
    case 'setLogisticsCompanyListAction':
      newstate.logisticsCompanyList = action.payload
      return newstate
    case 'setFileRequireAction':
      newstate.fileRequire = action.payload
      return newstate
    case 'setLogisticsInfoAction':
      newstate.logisticsInfo = action.payload
      return newstate
    case 'setDeleteFileIdsAction':
      newstate.deleteFileIds = action.payload
      return newstate
    case 'setSendTicketAddressTypeAction':
      newstate.sendTicketAddressType = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivleAction = (val: any): CustomAction<Action> => ({
  type: 'setIsAddModalVisivleAction',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeysAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setInvoiceDataAction',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): CustomAction<Action> => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

// 路由参数
export const setRouteParamsAction = (
  val: RouteParams,
): CustomAction<Action> => ({
  type: 'setRouteParamsAction',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})

// 原始对账单被删除的订单
export const setOriginRemovedListAction = (
  val: AllowAccountRes[],
): CustomAction<Action> => ({
  type: 'setOriginRemovedListAction',
  payload: val,
})

// 上传发票
export const setInvoiceBatchModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setInvoiceBatchModalVisibleAction',
  payload: val,
})

// 上传发票-类型
export const setInvoiceEntryTypeAction = (
  val: FinanicialInvoiceType,
): CustomAction<Action> => ({
  type: 'setInvoiceEntryTypeAction',
  payload: val,
})

// 批量上传loading
export const setBatchUploadLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setBatchUploadLoadingAction',
  payload: val,
})

// 发票表格数据
export const setInvoiceListDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setInvoiceListDataAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 发票价税合计
export const setAllInvoicePriceAction = (
  val: number,
): CustomAction<Action> => ({
  type: 'setAllInvoicePriceAction',
  payload: val,
})

// 订单价税合计
export const setAllOrderPriceAction = (val: any): CustomAction<Action> => ({
  type: 'setAllOrderPriceAction',
  payload: val,
})

// 提交新增发票
export const setAddInvoiceEntrySubmitAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setAddInvoiceEntrySubmitAction',
  payload: val,
})

// 发票详情弹框
export const setIsModalOpenAction = (val: boolean): CustomAction<Action> => ({
  type: 'setIsModalOpenAction',
  payload: val,
})

// 发票详情数据
export const setInvoiceDetailDataAction = (
  val: any[],
): CustomAction<Action> => ({
  type: 'setInvoiceDetailDataAction',
  payload: val,
})

// 当前选中的发票
export const setCurrentInvoiceAction = (val: any[]): CustomAction<Action> => ({
  type: 'setCurrentInvoiceAction',
  payload: val,
})

// 发票详情弹框表单修改
export const setInvoiceDetailChangeFlagAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setInvoiceDetailChangeFlagAction',
  payload: val,
})

// 当前选中发票的验真结果
export const setCheckingResultAction = (val: any): CustomAction<Action> => ({
  type: 'setCheckingResultAction',
  payload: val,
})

// 删除的发票id
export const setDelInvoiceIdListAction = (
  val: string[],
): CustomAction<Action> => ({
  type: 'setDelInvoiceIdListAction',
  payload: val,
})

// 删除的订单id
export const setDelOrderIdListAction = (
  val: string[],
): CustomAction<Action> => ({
  type: 'setDelOrderIdListAction',
  payload: val,
})

// 导出寄票随单提示
export const setExrpotInvoiceTipAction = (val: any): CustomAction<Action> => ({
  type: 'setExrpotInvoiceTipAction',
  payload: val,
})

// 暂存按钮loading
export const setIsTemporaryStorageLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTemporaryStorageLoadingAction',
  payload: val,
})

// 新增成功的发票单id
export const setAddInvoiceEntryIdAction = (
  val: string,
): CustomAction<Action> => ({
  type: 'setAddInvoiceEntryIdAction',
  payload: val,
})

// 发票详情页数据
export const setInvoiceDetailAction = (val: any): CustomAction<Action> => ({
  type: 'setInvoiceDetailAction',
  payload: val,
})

// 新增发票弹框提交按钮loading
export const setOkBtnLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setOkBtnLoadingAction',
  payload: val,
})

// 暂存按钮是否禁用
export const setTemporaryStorageDisabledAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setTemporaryStorageDisabledAction',
  payload: val,
})

// 页面loading
export const setPageLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setPageLoadingAction',
  payload: val,
})

// 物流公司列表
export const setLogisticsCompanyListAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setLogisticsCompanyListAction',
  payload: val,
})

// 发票附件必填
export const setFileRequireAction = (val: boolean): CustomAction<Action> => ({
  type: 'setFileRequireAction',
  payload: val,
})

// 物流信息
export const setLogisticsInfoAction = (val: {
  logisticsCompany: string
  logisticsNum: string
}): CustomAction<Action> => ({
  type: 'setLogisticsInfoAction',
  payload: val,
})

// 删除的发票附件id
export const setDeleteFileIdsAction = (
  val: string[],
): CustomAction<Action> => ({
  type: 'setDeleteFileIdsAction',
  payload: val,
})

/**
 *
 * @param val
 * @returns
 */
export const setSendTicketAddressTypeAction = (
  val: SendTicketAddressType,
): CustomAction<Action> => ({
  type: 'setSendTicketAddressTypeAction',
  payload: val,
})
import { AllowAccountRes } from '../../api/orderManage'
import { FinanicialInvoiceType } from './components/InvoiceEntryBatchModal'
import { ActionType, CustomAction } from '../../global'
import { orderTypeData } from '../../tools/util'

// 暂存/提交按钮类型
export type BtnType = 'temporaryStorage' | 'submit'
export const FINANCIAL_INVOICE_FILE_TYPE = '.pdf,.jpg,.png,.jpeg'
export type OrderType = (typeof orderTypeData)[number]['des']

export type SendTicketAddressType = '万聚' | '总部'
export type AddressInfo = {
  name: string
  phone: string
  address: string
  desp?: string
}
export const sendTicketAddressDict: Record<SendTicketAddressType, AddressInfo> =
  {
    总部: {
      name: '王婷燕',
      phone: '18814835585',
      address:
        '浙江省杭州市拱墅区永福桥路与新天地街交叉口南180米咸亨科技大厦8楼',
    },
    万聚: {
      name: '王亚',
      phone: '17855973107',
      address: '浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室',
    },
  }

export function joinAddressInfo(addressInfo: AddressInfo | null) {
  if (!addressInfo) {
    return ''
  }
  return `${addressInfo.name}，${addressInfo.phone}，${addressInfo.address}`
}
export interface RouteParams {
  data?: AllowAccountRes[]
  id?: string // 存在时为暂存、驳回状态 可以修改页面数据
  invoiceState?: string // 发票状态
  rejectReason?: string // 驳回原因
  invoiceData?: any[] // 发票列表
  type?: OrderType // 发票单类型
  orderType?: string
  titleOfTheContract?: string
  sendTicketAddressType?: SendTicketAddressType
}

interface State {
  dataSource: AllowAccountRes[]
  isAddModalVisivle: boolean
  selectedRowKeys: string[]
  selectedRows: AllowAccountRes[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  routeParams: RouteParams
  originRemovedList: AllowAccountRes[]
  invoiceBatchModalVisible: boolean
  batchUploadLoading: boolean
  invoiceEntryType: FinanicialInvoiceType
  invoiceListData: any[]
  previewFileUrl: string
  isPreviewModalVisible: boolean
  allInvoicePrice: number
  allOrderPrice: number
  addInvoiceEntrySubmit: boolean
  isModalOpen: boolean
  invoiceDetailData: any[]
  currentInvoice: any
  invoiceDetailChangeFlag: boolean
  checkingResult: any
  exrpotInvoiceTip: boolean
  delInvoiceIdList: string[]
  delOrderIdList: string[]
  isTemporaryStorageLoading: boolean
  addInvoiceEntryId: string
  invoiceDetail: any
  okBtnLoading: boolean
  temporaryStorageDisabled: boolean
  pageLoading: boolean
  logisticsCompanyList: any
  fileRequire: boolean
  logisticsInfo: {
    logisticsCompany: string
    logisticsNum: string
  }
  deleteFileIds: string[]
  sendTicketAddressType: undefined
}

type Action = ActionType<State>

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  selectedRows: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  routeParams: {
    data: [],
    id: '',
  },
  originRemovedList: [],
  invoiceBatchModalVisible: false,
  batchUploadLoading: false,
  invoiceEntryType: 'batchUpload',
  invoiceListData: [],
  previewFileUrl: '',
  isPreviewModalVisible: false,
  allInvoicePrice: 0,
  allOrderPrice: 0,
  addInvoiceEntrySubmit: false,
  isModalOpen: false,
  invoiceDetailData: [],
  currentInvoice: {},
  invoiceDetailChangeFlag: false,
  checkingResult: {},
  exrpotInvoiceTip: false,
  delInvoiceIdList: [],
  delOrderIdList: [],
  isTemporaryStorageLoading: false,
  addInvoiceEntryId: '',
  invoiceDetail: {},
  okBtnLoading: false,
  temporaryStorageDisabled: false,
  pageLoading: false,
  logisticsCompanyList: [],
  fileRequire: false,
  logisticsInfo: {
    logisticsCompany: '',
    logisticsNum: '',
  },
  deleteFileIds: [],
  sendTicketAddressType: undefined,
}

export default function reducer(
  state: State = initialState,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setIsAddModalVisivleAction':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceDataAction':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setOriginRemovedListAction':
      newstate.originRemovedList = action.payload
      return newstate
    case 'setInvoiceBatchModalVisibleAction':
      newstate.invoiceBatchModalVisible = action.payload
      return newstate
    case 'setBatchUploadLoadingAction':
      newstate.batchUploadLoading = action.payload
      return newstate
    case 'setInvoiceEntryTypeAction':
      newstate.invoiceEntryType = action.payload
      return newstate
    case 'setInvoiceListDataAction':
      newstate.invoiceListData = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setAllInvoicePriceAction':
      newstate.allInvoicePrice = action.payload
      return newstate
    case 'setAllOrderPriceAction':
      newstate.allOrderPrice = action.payload
      return newstate
    case 'setAddInvoiceEntrySubmitAction':
      newstate.addInvoiceEntrySubmit = action.payload
      return newstate
    case 'setIsModalOpenAction':
      newstate.isModalOpen = action.payload
      return newstate
    case 'setInvoiceDetailDataAction':
      newstate.invoiceDetailData = action.payload
      return newstate
    case 'setCurrentInvoiceAction':
      newstate.currentInvoice = action.payload
      return newstate
    case 'setInvoiceDetailChangeFlagAction':
      newstate.invoiceDetailChangeFlag = action.payload
      return newstate
    case 'setCheckingResultAction':
      newstate.checkingResult = action.payload
      return newstate
    case 'setExrpotInvoiceTipAction':
      newstate.exrpotInvoiceTip = action.payload
      return newstate
    case 'setDelInvoiceIdListAction':
      newstate.delInvoiceIdList = action.payload
      return newstate
    case 'setDelOrderIdListAction':
      newstate.delOrderIdList = action.payload
      return newstate
    case 'setIsTemporaryStorageLoadingAction':
      newstate.isTemporaryStorageLoading = action.payload
      return newstate
    case 'setAddInvoiceEntryIdAction':
      newstate.addInvoiceEntryId = action.payload
      return newstate
    case 'setInvoiceDetailAction':
      newstate.invoiceDetail = action.payload
      return newstate
    case 'setOkBtnLoadingAction':
      newstate.okBtnLoading = action.payload
      return newstate
    case 'setTemporaryStorageDisabledAction':
      newstate.temporaryStorageDisabled = action.payload
      return newstate
    case 'setPageLoadingAction':
      newstate.pageLoading = action.payload
      return newstate
    case 'setLogisticsCompanyListAction':
      newstate.logisticsCompanyList = action.payload
      return newstate
    case 'setFileRequireAction':
      newstate.fileRequire = action.payload
      return newstate
    case 'setLogisticsInfoAction':
      newstate.logisticsInfo = action.payload
      return newstate
    case 'setDeleteFileIdsAction':
      newstate.deleteFileIds = action.payload
      return newstate
    case 'setSendTicketAddressTypeAction':
      newstate.sendTicketAddressType = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivleAction = (val: any): CustomAction<Action> => ({
  type: 'setIsAddModalVisivleAction',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeysAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setInvoiceDataAction',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): CustomAction<Action> => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

// 路由参数
export const setRouteParamsAction = (
  val: RouteParams,
): CustomAction<Action> => ({
  type: 'setRouteParamsAction',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})

// 原始对账单被删除的订单
export const setOriginRemovedListAction = (
  val: AllowAccountRes[],
): CustomAction<Action> => ({
  type: 'setOriginRemovedListAction',
  payload: val,
})

// 上传发票
export const setInvoiceBatchModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setInvoiceBatchModalVisibleAction',
  payload: val,
})

// 上传发票-类型
export const setInvoiceEntryTypeAction = (
  val: FinanicialInvoiceType,
): CustomAction<Action> => ({
  type: 'setInvoiceEntryTypeAction',
  payload: val,
})

// 批量上传loading
export const setBatchUploadLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setBatchUploadLoadingAction',
  payload: val,
})

// 发票表格数据
export const setInvoiceListDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setInvoiceListDataAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 发票价税合计
export const setAllInvoicePriceAction = (
  val: number,
): CustomAction<Action> => ({
  type: 'setAllInvoicePriceAction',
  payload: val,
})

// 订单价税合计
export const setAllOrderPriceAction = (val: any): CustomAction<Action> => ({
  type: 'setAllOrderPriceAction',
  payload: val,
})

// 提交新增发票
export const setAddInvoiceEntrySubmitAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setAddInvoiceEntrySubmitAction',
  payload: val,
})

// 发票详情弹框
export const setIsModalOpenAction = (val: boolean): CustomAction<Action> => ({
  type: 'setIsModalOpenAction',
  payload: val,
})

// 发票详情数据
export const setInvoiceDetailDataAction = (
  val: any[],
): CustomAction<Action> => ({
  type: 'setInvoiceDetailDataAction',
  payload: val,
})

// 当前选中的发票
export const setCurrentInvoiceAction = (val: any[]): CustomAction<Action> => ({
  type: 'setCurrentInvoiceAction',
  payload: val,
})

// 发票详情弹框表单修改
export const setInvoiceDetailChangeFlagAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setInvoiceDetailChangeFlagAction',
  payload: val,
})

// 当前选中发票的验真结果
export const setCheckingResultAction = (val: any): CustomAction<Action> => ({
  type: 'setCheckingResultAction',
  payload: val,
})

// 删除的发票id
export const setDelInvoiceIdListAction = (
  val: string[],
): CustomAction<Action> => ({
  type: 'setDelInvoiceIdListAction',
  payload: val,
})

// 删除的订单id
export const setDelOrderIdListAction = (
  val: string[],
): CustomAction<Action> => ({
  type: 'setDelOrderIdListAction',
  payload: val,
})

// 导出寄票随单提示
export const setExrpotInvoiceTipAction = (val: any): CustomAction<Action> => ({
  type: 'setExrpotInvoiceTipAction',
  payload: val,
})

// 暂存按钮loading
export const setIsTemporaryStorageLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTemporaryStorageLoadingAction',
  payload: val,
})

// 新增成功的发票单id
export const setAddInvoiceEntryIdAction = (
  val: string,
): CustomAction<Action> => ({
  type: 'setAddInvoiceEntryIdAction',
  payload: val,
})

// 发票详情页数据
export const setInvoiceDetailAction = (val: any): CustomAction<Action> => ({
  type: 'setInvoiceDetailAction',
  payload: val,
})

// 新增发票弹框提交按钮loading
export const setOkBtnLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setOkBtnLoadingAction',
  payload: val,
})

// 暂存按钮是否禁用
export const setTemporaryStorageDisabledAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setTemporaryStorageDisabledAction',
  payload: val,
})

// 页面loading
export const setPageLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setPageLoadingAction',
  payload: val,
})

// 物流公司列表
export const setLogisticsCompanyListAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setLogisticsCompanyListAction',
  payload: val,
})

// 发票附件必填
export const setFileRequireAction = (val: boolean): CustomAction<Action> => ({
  type: 'setFileRequireAction',
  payload: val,
})

// 物流信息
export const setLogisticsInfoAction = (val: {
  logisticsCompany: string
  logisticsNum: string
}): CustomAction<Action> => ({
  type: 'setLogisticsInfoAction',
  payload: val,
})

// 删除的发票附件id
export const setDeleteFileIdsAction = (
  val: string[],
): CustomAction<Action> => ({
  type: 'setDeleteFileIdsAction',
  payload: val,
})

/**
 *
 * @param val
 * @returns
 */
export const setSendTicketAddressTypeAction = (
  val: SendTicketAddressType,
): CustomAction<Action> => ({
  type: 'setSendTicketAddressTypeAction',
  payload: val,
})
